import { render, staticRenderFns } from "./OnboardingWelcome.vue?vue&type=template&id=31c18c36"
import script from "./OnboardingWelcome.vue?vue&type=script&lang=js"
export * from "./OnboardingWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports